/* eslint-disable no-unused-vars */
import React from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { FirstName, LastName } from "../../utils/getName";

import "./About.css";

import profile from "../../assets/profile.jpg";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: "100vw",
    marginTop: "3em",
    marginBottom: "auto",
  },
}));

export const About = () => {
  const classes = useStyles();
  const greetings = "Hello there!";
  const aboutMe1 = `I'm ${FirstName} ${LastName}, Dedicated and efficient Full-Stack Engineer with 2 years of industrial experience. I am eager to solve problems and have pushed myself to learn the most effective ways to achieve a result. I can adapt to any technology rapidly making myself flexible upon any tech stack and can quickly integrate into a team.`;
  const aboutMe2 =
    "In my spare time, I like to travel, play video games, and catch my knowledge on upcoming tech trends.I'm always down for hearing about new projects, so feel free to drop me a line.";

  return (
    <section id="about">
      <Container component="main" className={classes.main} maxWidth="md">
        <div className="about">
          <div
            className="_img"
            style={{
              background: "url(" + profile + ")",
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="_content_wrapper">
            <Typography component="h2" variant="h5">
              <TextDecrypt text={`${greetings}`} />
            </Typography>
            <p className="aboutme">{aboutMe1}</p>
            <p className="aboutme">{aboutMe2}</p>
            <a href="#contact" className="contact-btn">
              <i className="fas fa-terminal"></i>
              <Typography component="span">
                {" "}
                Send me a message.
              </Typography>
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};
